<template>
  <div class="bfp">
    <!-- ===== 筛选面板（与「快捷入口」内嵌面板同款：枚举 chips / 区间滚轮 / 可搜索选择器） ===== -->
    <van-popup
      :value="value"
      position="bottom"
      round
      :style="{ height: '78%' }"
      @input="v => $emit('input', v)"
    >
      <div class="bill-filter">
        <div class="bill-filter__hd">
          <span class="bill-filter__title">{{ headTitle }}</span>
          <van-icon name="cross" class="bill-sheet__close" @click="$emit('input', false)" />
        </div>
        <div class="bill-filter__bd">
          <template v-if="visibleFilters.length">
            <div class="bill-filter__group" v-for="f in visibleFilters" :key="f.prop">
              <div class="bill-filter__label">
                <span>{{ f.label }}</span>
                <span class="bill-filter__reset" v-if="draftOn(f)" @click="clearDraft(f)">清除</span>
              </div>

              <!-- ① 日期区间：滚轮选择 -->
              <div class="bill-filter__range" v-if="f.type === 'daterange'">
                <div
                  class="bill-filter__pick"
                  :class="{ 'bill-filter__pick--on': !!draft[dk(f, 'begin')] }"
                  @click="openDate(dk(f, 'begin'))"
                >{{ draft[dk(f, 'begin')] || '开始日期' }}</div>
                <span class="bill-filter__sep">~</span>
                <div
                  class="bill-filter__pick"
                  :class="{ 'bill-filter__pick--on': !!draft[dk(f, 'end')] }"
                  @click="openDate(dk(f, 'end'))"
                >{{ draft[dk(f, 'end')] || '结束日期' }}</div>
              </div>

              <!-- ② 金额区间 -->
              <div class="bill-filter__range" v-else-if="f.type === 'amountRange'">
                <input
                  class="bill-filter__input"
                  type="number" inputmode="decimal"
                  :value="draft.amount_begin"
                  placeholder="最低金额"
                  @input="setDraft('amount_begin', $event.target.value)"
                />
                <span class="bill-filter__sep">~</span>
                <input
                  class="bill-filter__input"
                  type="number" inputmode="decimal"
                  :value="draft.amount_end"
                  placeholder="最高金额"
                  @input="setDraft('amount_end', $event.target.value)"
                />
              </div>

              <!-- ③ 可搜索选择器（客户 / 商机 / 销售合同 / 财务合同） -->
              <div
                class="bill-filter__pick bill-filter__pick--full"
                v-else-if="f.type === 'remote'"
                :class="{ 'bill-filter__pick--on': !!draft[f.prop] }"
                @click="openRemote(f)"
              >
                <span class="bill-filter__picktx">{{ remoteText(f) || (f.placeholder || '全部') }}</span>
                <van-icon name="arrow" class="bill-filter__arrow" />
              </div>

              <!-- ④ 关键字 -->
              <input
                class="bill-filter__input"
                v-else-if="f.type === 'search'"
                :value="draft.searchText"
                :placeholder="f.placeholder || '请输入关键字'"
                @input="setDraft('searchText', $event.target.value)"
              />

              <!-- ⑤ 枚举 chips（首项「全部」，默认全部） -->
              <div class="bill-filter__chips" v-else>
                <span
                  class="bill-filter__chip"
                  :class="{ 'bill-filter__chip--on': !draftOn(f) }"
                  @click="setDraft(f.prop, '')"
                >全部</span>
                <span
                  class="bill-filter__chip"
                  v-for="o in optionsOf(f)"
                  :key="String(o.value)"
                  :class="{ 'bill-filter__chip--on': String(draft[f.prop]) === String(o.value) }"
                  @click="setDraft(f.prop, o.value)"
                >{{ o.label || o.text }}</span>
              </div>
            </div>
          </template>
          <div class="bill-sheet__loading" v-else>该单据暂无可筛选维度</div>
        </div>
        <div class="bill-filter__ft">
          <div class="btn-action btn-action--secondary" @click="resetFilter"><span>重置</span></div>
          <div class="btn-action btn-action--primary" @click="applyFilter"><span>确定</span></div>
        </div>
      </div>
    </van-popup>

    <!-- ===== 日期滚轮 ===== -->
    <van-popup v-model="dateShow" position="bottom" round>
      <van-datetime-picker
        type="date"
        :title="dateTitle"
        :value="dateCur"
        :min-date="dateMin"
        :max-date="dateMax"
        @cancel="dateShow = false"
        @confirm="onDateConfirm"
      />
    </van-popup>

    <!-- ===== 可搜索选择器弹层 ===== -->
    <van-popup v-model="remoteShow" position="bottom" :style="{ height: '72%' }" round>
      <div class="bill-picker">
        <div class="bill-picker__hd">
          <span class="bill-picker__title">{{ remoteTitle }}</span>
          <van-icon name="cross" class="bill-sheet__close" @click="remoteShow = false" />
        </div>
        <div class="bill-picker__search">
          <van-icon name="search" class="bill-picker__kwico" />
          <input
            class="bill-picker__kwin"
            v-model="remoteKeyword"
            :placeholder="remotePlaceholder"
            @input="onRemoteInput"
          />
          <van-icon name="clear" class="bill-picker__kwclr" v-if="remoteKeyword" @click="clearRemoteKw" />
        </div>
        <div class="bill-picker__bd">
          <div
            class="bill-picker__item"
            :class="{ 'bill-picker__item--on': !draft[remoteProp] }"
            @click="pickRemote('')"
          >
            <div class="bill-picker__nm">全部</div>
          </div>
          <div
            class="bill-picker__item"
            v-for="o in remoteList"
            :key="String(o.value)"
            :class="{ 'bill-picker__item--on': String(draft[remoteProp]) === String(o.value) }"
            @click="pickRemote(o.value)"
          >
            <div class="bill-picker__nm">{{ o.text }}</div>
            <div class="bill-picker__sub" v-if="o.sub">{{ o.sub }}</div>
          </div>
          <div class="bill-sheet__loading" v-if="remoteLoading">加载中…</div>
          <div class="bill-sheet__loading" v-else-if="!remoteList.length">暂无可选项</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
/* ============================================================================
 * BillFilterPanel —— 单据筛选面板（通用共用组件）
 * ----------------------------------------------------------------------------
 * 【设计目标】把「快捷入口」内嵌的 chips 式筛选面板抽成独立组件，供
 *   ① 合同详情内的单据列表（会议室订单 / 支付单等）
 *   ② 后续任何需要同款筛选的页面
 * 复用，避免多处各写一套导致交互/样式漂移。
 *
 * 【控件口径（与快捷入口 1:1）】
 *   type='daterange'   → 两个浅灰可点块 + 「~」，点开为 vant 日期滚轮
 *   type='amountRange' → 两个数字输入 + 「~」
 *   type='remote'      → 浅灰整行 + 右侧 › ，点开为「可搜索选择器」弹层（含关键字搜索）
 *   type='search'      → 文本输入（写入 draft.searchText，由父级并入 searchText 参数）
 *   其余（含 type='select'）→ chips 药丸：首项固定「全部」+ 各项，单选高亮
 *
 * 【选项来源（optionsOf 三级兜底）】
 *   1. f.options 内联（如「是否免费」）—— 兼容 {label} 与 {text} 两种写法
 *   2. billTypes.maps（后端字典，按 billType 取；与快捷入口同源）
 *   3. extraOptions（受理人等单接口字典）
 *
 * 【契约】
 *   props : value(v-model 显隐) / filters(维度数组,必传) / applied(已生效值) /
 *           title / apiPrefix / billType / maskAmount
 *   emits : input(显隐) / apply(payload, labels) / reset()
 *   ⚠️ draft 的写入一律走 this.$set —— Vue2 对实例化后新增属性不做响应式劫持，
 *      直接赋值会出现「筛选点了没反应」的假死。
 * ========================================================================== */
import {
  getBillTypesData,
  getFinanceBillTypesData,
  getMarketBillTypesData,
  getOperationBillTypesData,
  getBillFilterOptionsData,
  getPaymentOwnerOptions
} from '../api/api.js'

function ymd(d) {
  if (!d) return ''
  if (typeof d === 'string') return d.slice(0, 10)
  const p = (n) => (n < 10 ? '0' + n : '' + n)
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}

export default {
  name: 'BillFilterPanel',
  props: {
    /** v-model：面板显隐 */
    value: { type: Boolean, default: false },
    /** 筛选维度（来自单据配置 src/pages/contract/*.js 的 filters） */
    filters: { type: Array, default: () => [] },
    /** 已生效的筛选值（用于回填草稿） */
    applied: { type: Object, default: () => ({}) },
    /** 面板标题（默认「筛选」） */
    title: { type: String, default: '筛选' },
    /** 接口前缀：client / finance / market / operation */
    apiPrefix: { type: String, default: 'client' },
    /** 单据类型（取值 billTypes.maps 用），如 room / payment */
    billType: { type: String, default: '' },
    /** 金额脱敏：隐去「金额区间」维度 */
    maskAmount: { type: Boolean, default: false }
  },
  data() {
    return {
      draft: {},
      mapsDict: {},
      extraOptions: {},
      remoteOptions: {},
      remoteShow: false,
      remoteProp: '',
      remoteTitle: '',
      remoteKind: '',
      remotePlaceholder: '搜索',
      remoteKeyword: '',
      remoteLoading: false,
      dateShow: false,
      dateKey: '',
      dateTitle: '选择日期',
      dateCur: new Date(),
      dateMin: new Date(2018, 0, 1),
      dateMax: new Date(2032, 11, 31)
    }
  },
  computed: {
    headTitle() {
      return this.title || '筛选'
    },
    visibleFilters() {
      const fs = Array.isArray(this.filters) ? this.filters : []
      const base = this.maskAmount ? fs.filter(f => f.type !== 'amountRange') : fs
      /* remote 类依赖 client/billFilterOptions，仅销售端可用 */
      if (this.apiPrefix === 'client') return base
      return base.filter(f => f.type !== 'remote')
    },
    remoteList() {
      return (this.remoteOptions && this.remoteOptions[this.remoteProp]) || []
    }
  },
  watch: {
    value(v) {
      if (v) this.openPanel()
    }
  },
  mounted() {
    this.loadDict()
  },
  methods: {
    /* ---------- 打开面板：回填草稿 + 预热已选 remote 的展示名 ---------- */
    openPanel() {
      this.draft = Object.assign({}, this.applied || {})
      this.visibleFilters.forEach(f => {
        if (f.type === 'remote' && this.draft[f.prop]) {
          this.remoteProp = f.prop
          this.remoteKind = f.kind || ''
          this.remoteKeyword = ''
          this.loadRemote()
        }
      })
    },

    /* ---------- 字典 ---------- */
    apiTypes(p) {
      if (this.apiPrefix === 'finance') return getFinanceBillTypesData(p)
      if (this.apiPrefix === 'market') return getMarketBillTypesData(p)
      if (this.apiPrefix === 'operation') return getOperationBillTypesData(p)
      return getBillTypesData(p)
    },
    loadDict() {
      this.apiTypes({}).then(res => {
        const d = (res && res.code === 200 && res.data) ? res.data : null
        const types = d && Array.isArray(d.types) ? d.types : []
        const dict = {}
        types.forEach(t => {
          const m = t.maps || {}
          const one = {}
          Object.keys(m).forEach(col => {
            const src = m[col] || {}
            one[col] = Object.keys(src).map(k => ({ value: k, label: src[k] }))
          })
          dict[t.value] = one
        })
        this.mapsDict = dict
      }).catch(() => {})
      /* 受理人（部分单据用，走既有 orderPaymentOwnerOptions） */
      getPaymentOwnerOptions({}).then(res => {
        const d = (res && res.code === 200 && res.data) ? res.data : null
        const list = d && (Array.isArray(d) ? d : (Array.isArray(d.list) ? d.list : null))
        if (list && list.length) {
          this.extraOptions = Object.assign({}, this.extraOptions, {
            owner: list.map(x => ({
              value: x.value !== undefined ? x.value : (x.id !== undefined ? x.id : x.staff_id),
              label: x.label || x.text || x.name
            }))
          })
        }
      }).catch(() => {})
    },

    /* ---------- 草稿读写（一律 $set） ---------- */
    setDraft(k, v) {
      this.$set(this.draft, k, v)
    },
    dk(f, which) {
      if (which === 'begin') return f.beginKey || (f.prop + '_begin')
      return f.endKey || (f.prop + '_end')
    },
    draftOn(f) {
      if (!f) return false
      if (f.type === 'daterange') {
        return !!this.draft[this.dk(f, 'begin')] || !!this.draft[this.dk(f, 'end')]
      }
      if (f.type === 'search') return !!this.draft.searchText
      const v = this.draft[f.prop]
      return !(v === undefined || v === null || v === '')
    },
    clearDraft(f) {
      if (!f) return
      if (f.type === 'daterange') {
        this.setDraft(this.dk(f, 'begin'), '')
        this.setDraft(this.dk(f, 'end'), '')
        return
      }
      if (f.type === 'search') { this.setDraft('searchText', ''); return }
      this.setDraft(f.prop, '')
    },

    /* ---------- 选项（三级兜底 + 归一为 {value,label}） ---------- */
    optionsOf(f) {
      const norm = (arr) => (arr || []).map(o => ({ value: o.value, label: o.label || o.text || '' }))
      if (f.options && f.options.length) return norm(f.options)
      const dict = (this.billType && this.mapsDict[this.billType]) ? this.mapsDict[this.billType] : {}
      /* 【P227】门店 → 会议室 二级联动：
         声明了 dependsOn 的字段（如会议室依赖门店）先取全量，再按 draft 里
         已选的父级值过滤；options 项须带归属字段 store_sn。
         未选父级时列全部。这样无需父组件回传，筛选面板内部自洽。 */
      if (f.dependsOn) {
        const parentVal = this.draft ? this.draft[f.dependsOn] : ''
        const src = (f.optionsFn && dict[f.optionsFn]) ? dict[f.optionsFn]
          : (f.optionsFn && this.extraOptions[f.optionsFn] ? this.extraOptions[f.optionsFn] : [])
        const all = src || []
        if (!parentVal) return all
        return all.filter(o => String(o.store_sn || '') === String(parentVal))
      }
      if (f.optionsFn && dict[f.optionsFn] && dict[f.optionsFn].length) return dict[f.optionsFn]
      if (f.optionsFn && this.extraOptions[f.optionsFn]) return this.extraOptions[f.optionsFn]
      return []
    },

    /* ---------- 日期滚轮 ---------- */
    openDate(key) {
      if (!key) return
      this.dateKey = key
      const cur = this.draft[key]
      this.dateTitle = '选择日期'
      this.dateCur = cur ? new Date(String(cur).slice(0, 10).replace(/-/g, '/')) : new Date()
      this.dateShow = true
    },
    onDateConfirm(v) {
      const s = ymd(v)
      if (this.dateKey) this.setDraft(this.dateKey, s)
      this.dateShow = false
    },

    /* ---------- 可搜索选择器 ---------- */
    remoteText(f) {
      const v = this.draft[f.prop]
      if (v === undefined || v === null || v === '') return ''
      const o = (this.remoteOptions[f.prop] || []).find(x => String(x.value) === String(v))
      return o ? o.text : '已选 1 项'
    },
    openRemote(f) {
      this.remoteProp = f.prop
      this.remoteTitle = f.label || '请选择'
      this.remoteKind = f.kind || ''
      this.remotePlaceholder = f.placeholder || ('搜索' + (f.label || ''))
      this.remoteKeyword = ''
      this.remoteShow = true
      if (!this.remoteKind) return
      this.loadRemote()
    },
    onRemoteInput() {
      clearTimeout(this.__rmTimer)
      this.__rmTimer = setTimeout(() => this.loadRemote(), 280)
    },
    clearRemoteKw() {
      this.remoteKeyword = ''
      this.loadRemote()
    },
    loadRemote() {
      if (!this.remoteKind) return Promise.resolve()
      this.remoteLoading = true
      const prop = this.remoteProp
      return getBillFilterOptionsData({ kind: this.remoteKind, keyword: this.remoteKeyword }).then(res => {
        this.remoteLoading = false
        const d = (res && res.code === 200 && res.data) ? res.data : null
        const list = d && Array.isArray(d.list) ? d.list : []
        this.$set(this.remoteOptions, prop, list)
      }).catch(() => { this.remoteLoading = false })
    },
    pickRemote(v) {
      this.setDraft(this.remoteProp, v)
      this.remoteShow = false
    },

    /* ---------- 重置 / 确定 ---------- */
    resetFilter() {
      /* 整体替换才能保证 Vue2 重新收集依赖（draft 是 data 属性，替换即响应式） */
      this.draft = {}
    },
    applyFilter() {
      const next = {}
      Object.keys(this.draft).forEach(k => {
        const v = this.draft[k]
        if (v !== undefined && v !== null && v !== '') next[k] = v
      })
      const labels = this.labelsOf(next)
      this.$emit('input', false)
      this.$emit('apply', next, labels)
    },
    /** 已生效条件的可读文案（父级用于渲染「筛选：xxx · yyy」状态条） */
    labelsOf(val) {
      const out = []
      const v = val || {}
      this.visibleFilters.forEach(f => {
        if (f.type === 'amountRange') {
          if (v.amount_begin) out.push('金额起：' + v.amount_begin)
          if (v.amount_end) out.push('金额止：' + v.amount_end)
          return
        }
        if (f.type === 'daterange') {
          const b = v[this.dk(f, 'begin')]
          const e = v[this.dk(f, 'end')]
          if (b) out.push(f.label + '起：' + b)
          if (e) out.push(f.label + '止：' + e)
          return
        }
        if (f.type === 'remote') {
          if (v[f.prop]) {
            const o = (this.remoteOptions[f.prop] || []).find(x => String(x.value) === String(v[f.prop]))
            out.push(f.label + '：' + (o ? o.text : '已选'))
          }
          return
        }
        const cur = v[f.prop]
        if (cur === undefined || cur === null || cur === '') return
        const o = this.optionsOf(f).find(x => String(x.value) === String(cur))
        out.push(f.label + '：' + (o ? (o.label || o.text) : cur))
      })
      if (v.searchText) out.push('关键字「' + v.searchText + '」')
      return out
    }
  }
}
</script>

<style scoped>
/* ============================================================
 * 【P206】变量兜底 —— 必须自带一份！
 *   bill-list.css 的 --bill-brand* 等变量定义在 .bill-list 作用域内，
 *   本组件可能渲染在 .bill-list 之外（如合同详情单据页），
 *   此时 var(--bill-brand-soft) 无 fallback ⇒ 计算值非法 ⇒ chips 选中态
 *   背景变透明、「全部」高亮丢失。故在本组件根节点补同一套兜底变量
 *   （CSS 变量沿 DOM 继承，popup 亦为后代，可正常取到）。
 * ============================================================ */
.bfp {
  /* 普通包裹层（子节点均为 fixed 定位的 popup，无视觉影响）；
     不用 display:contents，确保自定义属性沿 DOM 树继承万无一失。 */
  --bill-brand: var(--brand, #2b5fd9);
  --bill-brand-2: var(--brand-2, #4a8af0);
  --bill-brand-soft: var(--brand-soft, #eef2fb);
  --bill-t1: var(--text-1, #1d2129);
  --bill-t2: var(--text-2, #323233);
  --bill-t3: var(--text-3, #969799);
  --bill-line: var(--border, #ebedf0);
  --bill-divider: var(--divider, #f2f3f5);
  --bill-radius: var(--radius, 12px);
  --bill-radius-lg: var(--radius-lg, 16px);
}
</style>



// WEBPACK FOOTER //
// src/components/BillFilterPanel.vue